"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = is;

/**
 * @file 全民小视频 ua校验
 * @author zhangyanting@baidu.com
 */

/**
 * 判断当前浏览器是否为全民小视频
 *
 * @return {boolean} 判断当前浏览器是否为全民小视频
 */
function is() {
  return /bdminivideo\//i.test(navigator.userAgent);
}